module.exports = __webpack_public_path__ + "src/assets/img/pic (5).1bba5f62.jpg";